import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const MicOffIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="28"
    height="28"
    viewBox="0 0 28 28"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      opacity="0.2"
      d="M18.375 7C18.375 4.58375 16.4162 2.625 14 2.625C11.5838 2.625 9.625 4.58375 9.625 7V14C9.625 16.4162 11.5838 18.375 14 18.375C16.4162 18.375 18.375 16.4162 18.375 14V7Z"
      fill="white"
    />
    <path
      d="M19.293 19.8297C18.2191 20.8063 16.8962 21.4671 15.4704 21.7391C14.0446 22.0111 12.5714 21.8838 11.2134 21.3711C9.85539 20.8585 8.66551 19.9805 7.77515 18.8341C6.88478 17.6878 6.32858 16.3176 6.16797 14.875"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9422 17.2375C16.1393 17.973 15.0888 18.3791 14 18.375V18.375C12.8397 18.375 11.7269 17.9141 10.9064 17.0936C10.0859 16.2731 9.625 15.1603 9.625 14V9.1875"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 21.875V25.375"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 4.375L22.75 23.625"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2812 4.70313C10.6711 4.06714 11.2179 3.542 11.8691 3.17809C12.5202 2.81419 13.254 2.62374 14 2.62501V2.62501C15.1603 2.62501 16.2731 3.08594 17.0936 3.90641C17.9141 4.72689 18.375 5.83968 18.375 7.00001V13.6063"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.832 14.875C21.7549 15.5571 21.5895 16.2262 21.3398 16.8656"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
